export interface DepartmentGendersProperties {
  [key: string]: string[];
  Men: string[];
  Women: string[];
  Unisex: string[];
  Boys: string[];
  Girls: string[];
  Kids: never[];
  Baby: never[];
}

const departmentGenders: DepartmentGendersProperties = {
  Men: ['MEN'],
  Women: ['WOMEN'],
  Unisex: ['MEN', 'WOMEN'],
  Boys: ['MEN'],
  Girls: ['WOMEN'],
  Kids: [],
  Baby: [],
};

export default departmentGenders;
